module.exports = __webpack_public_path__ + "img/nfykdaxfsds.16c4c92c.png";